import { Step } from '../../Stepper';

export default Step;
